import { useGeoDataContext } from '@contexts/GeoDataContext.tsx';
import type { SelectInputOption, SelectInputProps } from '@gurupay/gp-ui-library';
import { SelectInput } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useState } from 'react';
import Flag from 'react-world-flags';

export const CountrySelector: FC<
	Omit<SelectInputProps<string>, 'options'> & { options?: SelectInputOption<string>[] }
> = (props) => {
	const geoData = useGeoDataContext();
	const [filter, setFilter] = useState<string | undefined>();
	const countryOptions = (
		props?.options ??
		(geoData?.data?.countries as SelectInputOption<string>[]) ??
		[]
	).map((country: SelectInputOption<string>) => ({
		...country,
		icon: (
			<Flag
				className="h-[20px] w-[20px] object-cover rounded-full"
				code={country.value}
			/>
		),
	}));
	const filteredOptions = filter
		? countryOptions.filter((option) =>
				option.label.toLowerCase().startsWith(filter.toLowerCase()),
			)
		: countryOptions;

	return (
		<SelectInput {...props} onSearch={setFilter} options={filteredOptions} showClear />
	);
};
